import axios from "axios";
import { req } from "./axiosFun";
import CryptoJS from "crypto-js";
/**
 * 商品管理
 **/
// 商品管理-获取商品管理列表
export const unitPriceList = (enterprisePayId) => {
  return req(
    "get",
    `/api/unitPrice/list?enterprisePayId=${enterprisePayId}`
  );
};

export const enterpriseBalance = (enterprisePayId) => {
  return req(
    "get",
    `/api/enterprise/balance?enterprisePayId=${enterprisePayId}`
  );
};

export const orderCreate = (params) => {
  return req("post", "/api/order/create/v2", params);
};



export const rechargeCreate = (params) => {
  return req("post", "/api/user/recharge", params);
};
export const list = (params) => {
  return req(
    "get",
    `/api/order/list?keywords=${params.keywords}`
  );
};

export const dashboard = () => {
  return req("get", "/api/dashboard");
};
export const userCreate = (params) => {
  return req("post", "/api/user/create", params);
};
export const userLogin = (params) => {
  return req("post", "/api/user/login", params);
};
/**
 * 机器信息管理
 **/
// 机器信息管理-获取机器信息管理列表
export const MachineList = (params) => {
  return req("post", "/api/Machine/list", params);
};
// 机器信息管理-保存机器信息管理
export const MachineSave = (params) => {
  return req("post", "/api/Machine/save", params);
};
// 机器信息管理-删除机器信息管理
export const MachineDelete = (params) => {
  return axios
    .delete(
      "/api/Machine/delete?ids=" +
        params +
        "&token=" +
        localStorage.getItem("logintoken")
    )
    .then((res) => res.data);
};

/**
 * 货道信息管理
 **/
// 货道信息管理-获取获取货道信息管理列表
export const MachineAisleList = (params) => {
  return req("post", "/api/MachineAisle/list", params);
};
// 货道信息管理-删除货道信息管理
export const MachineAisleDelete = (params) => {
  return axios
    .delete(
      "/api/MachineAisle/delete?ids=" +
        params +
        "&token=" +
        localStorage.getItem("logintoken")
    )
    .then((res) => res.data);
};
// 货道信息管理-保存货道信息管理
export const MachineAisleRsave = (params) => {
  return req("post", "/api/MachineAisle/save", params);
};
export const editPwd = (params) => {
  return req("put", "/api/user/updatePass", params);
};

export const getUserInfo = () => {
  return req("get", "/api/user/info");
};

export const sortJson = (jsonData) => {
  try {
    let jsonObj = JSON.parse(jsonData);
    let sortedObj = {};
    Object.keys(jsonObj)
      .sort()
      .forEach(function (key) {
        sortedObj[key] = jsonObj[key];
      });
    return JSON.stringify(sortedObj);
  } catch (e) {
    console.error("json字段排序失败:" + e.message);
    return null;
  }
};
export const getDigest = (jsonData, payKey) => {
  try {
    jsonData = sortJson(jsonData);
    if (!jsonData) {
      return jsonData;
    }
    let encryptData = jsonData + payKey;
    let sha256Hex = CryptoJS.SHA256(encryptData).toString(CryptoJS.enc.Hex);
    return btoa(sha256Hex);
  } catch (e) {
    return null;
  }
};


const AES_KEY = "tronEnergy202403111706TE";
const IV = "TRON202403ENERGY";
export const aesDecrypt = (encryptedBase64Data) => {
  // 将密钥和IV转换成WordArray格式
  var key = CryptoJS.enc.Utf8.parse(AES_KEY);
  var iv = CryptoJS.enc.Utf8.parse(IV);

  // 先将Base64编码的加密数据解码为WordArray
  var encrypted = CryptoJS.enc.Base64.parse(encryptedBase64Data);

  // 使用AES解密（CBC模式，PKCS7填充）
  var decrypted = CryptoJS.AES.decrypt(
      {ciphertext: encrypted}, 
      key, 
      {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7}
  );

  // 返回解密后的明文字符串
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const aesEncrypt = (data) => {
  // 将密钥和IV转换成WordArray格式
  var key = CryptoJS.enc.Utf8.parse(AES_KEY);
  var iv = CryptoJS.enc.Utf8.parse(IV);

  // 使用AES加密（CBC模式，PKCS7填充）
  var encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
  });

  // 返回Base64编码的加密数据
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

// 获取地址列表
export const getAddressList = () => {
  return req("get", "/api/address/list");
};

// 添加地址
export const createAddress = (params) => {
  return req("post", "/api/address/create", params);
};

// 删除地址
export const deleteAddress = (id) => {
  return req("delete", `/api/address/${id}`);
};

// 创建监控地址
export const createMonitorAddress = (params) => {
  return req("post", "/api/monitorAddress/create", params);
};

// 获取监控地址列表
export const getMonitorAddressList = () => {
  return req("get", "/api/monitorAddress/list");
};

// 删除监控地址
export const deleteMonitorAddress = (id) => {
  return req("delete", `/api/monitorAddress/${id}`);
};

export const listWithLogin = () => {
  return req("get", "/api/unitPrice/listWithLogin");
};

export const updateBalanceNotify = (params) => {
  return req("put", "/api/user/balanceNotify", params);
};

// 更新监听间隔设置
export const updateMonitorNotifyInterval = (params) => {
  return req("put", "/api/user/monitorNotifyInterval", params);
};


// WEBPACK FOOTER //
// ./src/api/basisMG.js